import { t } from "i18next";
import * as React from "react";
import { Action, mk_widget, Widget } from "widgets-for-react";
import { AppState } from "../../cms/state/types.gen";
import { get_lang_from_url } from "../../map/maps_utils";
import { PublicSiteState } from "../../public_site.main.mod";
import { PublicSiteCustomRoutes } from "../custom_pages/types.mod";
import NavItems from "./nav_items";

export const footer: (
  s: AppState<PublicSiteState, PublicSiteCustomRoutes>
) => Widget<
  Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
> = props =>
  mk_widget({
    run: o => (
      <>
      <footer className="footer">
        <div className="footer__inner container--xl grid--block">
          <div className="footer__logo">
            <a href={window.wp.language == 'en' ? "/" : "/nl" }>
              <img src="/frontend/images/logo-subtitle.svg" alt="FrieslandCampina logo" />
            </a>
          </div>

          <nav className="footer__nav nav nav--footer typo--s">
            <NavItems location='footer' cssClass={'bottom'} hasActiveState={false} />
          </nav>


          <div className="footer__socials">
            <h2 className="socials__title typo--s">{t("footer.follow_us")}</h2>
            <ul className="socials">
              <li className="socials__item">
                <a className="socials__link socials__link--facebook" href="https://www.facebook.com/FrieslandCampina/" target="_blank" ></a>
              </li>
              <li className="socials__item">
                <a className="socials__link socials__link--twitter" href="https://twitter.com/FrieslndCampina" target="_blank"></a>
              </li>
              <li className="socials__item">
                <a className="socials__link socials__link--instagram" href="https://www.instagram.com/frieslandcampina.careers/" target="_blank"></a>
              </li>
              <li className="socials__item">
                <a className="socials__link socials__link--linkedin" href="https://www.linkedin.com/organization-guest/company/frieslandcampina" target="_blank"></a>
              </li>
              {get_lang_from_url(_ => "") != "/ng" ? (
              <li className="socials__item">
                  <a className="socials__link socials__link--rss" href={`${get_lang_from_url(_ => "")}/rss`}></a>
              </li>
              ) : null}
            </ul>

            <NavItems location='copyright' cssClass={'copyright typo--4xs'} hasActiveState={false} after={
              <li className="nav__item nav__item--copyright">
                <a className="optanon-toggle-display nav__link nav__link--copyright">Cookie settings</a>
              </li>
            } />
          </div>
        </div>

        <img
          className="footer__image footer__image--mobile"
          src="/frontend/images/footer-bground-mobile.jpg"
          alt="Image of cows"
        />
         <img
          className="footer__image footer__image--desktop"
          src="/frontend/images/footer-bground-desktop.jpg"
          alt="Image of cows"
        />
      </footer>
      {/* <Icons /> */}
      </>
    )
  });